import { Box, Stack, styled } from '@mui/material';

export const StyledLineWrapper = styled(Stack)(({ theme }) => ({
  position: 'relative',
  width: '1px',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    width: 'auto',
    marginRight: theme.spacing(4),
  },
}));
export const StyledDot = styled(`img`)(() => ({
  height: '17px',
  width: '17px',
  position: 'absolute',
  zIndex: 2,
  left: '-7.5px',
}));
export const StyledDottedLine = styled(Box)(({ theme }) => ({
  position: 'absolute',
  height: '100%',
  borderLeft: `2.5px dotted ${theme.palette.colorWhite}`,
  opacity: 0.15,
  index: 0,
}));
export const StyledLine = styled(Box)(({ theme }) => ({
  position: 'absolute',
  borderLeft: `2.5px solid ${theme.palette.colorWhite}`,
  index: 1,
}));
